const userCreatedAccountViaFacebook = (loggedInUser) => {
  return loggedInUser.providerData.length === 1 && loggedInUser.providerData[0].providerId === 'facebook.com'
}

export default userCreatedAccountViaFacebook
